import React from 'react'
import { Booking } from '../../components'

const booking = () => {
  return (
    <div>
      <Booking />
    </div>
  )
}

export default booking
